/**
 * For each state, create a new key and value pair.
 * The key is used to identify @{this} state for that particular object
 */
const StorageStateKeys = {
  rootState: "appState",
  usersStateKey: "usersStateKey",
};

export const VIEW_STATE = {
  CREATE: "CREATE",
  EDIT: "EDIT",
  DELETE: "DELETE",
  VIEW: "VIEW",
  LIST: "LIST",
};

export const PAGE_MATCHED = {
  EDIT_VIEW: "MATCH_EDIT_VIEW",
  CREATE_NEW_VIEW: "MATCH_CREATE_NEW_VIEW",
  DETAILS_VIEW: "MATCH_DETAILS_VIEW",
  LANDING_VIEW: "MATCH_LANDING",
};

export const PERIOD_TO_RELATIVE = {
  Week: "Last 7 days",
  Month: "Last 30 days",
  Year: "Last 12 months",
};

export const QUIZ_TYPE_MAPPING = {
  NODE: "In Depth Learning",
  CASE: "Case Based Learning",
  GUIDELINE: "Guidelines",
};

export const LOGOS = [
  { name: "MoH", src: "/images/moh-logo.png" },
  { name: "MCM", src: "/images/mcm-logo.webp" },
  { name: "LSHTM", src: "/images/lshtm-logo.svg" },
  { name: "KUHES", src: "/images/kuhes-logo.svg" },
  { name: "UNIMA", src: "/images/unima-logo.png" },
];

export const COLORS = [
  "#5470C6",
  "#91CC75",
  "#EE6666",
  "#FAC858",
  "#73C0DE",
  "#3BA272",
  "#FC8452",
  "#9A60B4",
  "#EA7CCC",
];

export default StorageStateKeys;
